export class InfoTopicMessageRequest {
  sMsg: string;

  constructor(message: string = null) {
    this.sMsg = message;
  }
}
